<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/nike/products/*', { eager: true });

useHead({});

const products = [
	{
		title: "Snapback Mesh Trucker Cap",
		src: imagesGlob["../../images/brands/nike/products/swaggerproductpagewebsiteproductsnike6snapback-mesh-trucker-cap.png"].default
	},
	{
		title: "Club Fleece Crew",
		src: imagesGlob["../../images/brands/nike/products/swaggerproductpagewebsiteproductsnike10club-fleece-crew.png"].default
	},
	{
		title: "Brasilia Small Duffel",
		src: imagesGlob["../../images/brands/nike/products/swaggerproductpagewebsiteproductsnike9brasilia-small-duffel.png"].default
	},
	{
		title: "Dry 1/2 Zip Cover-Up",
		src: imagesGlob["../../images/brands/nike/products/swaggerproductpagewebsiteproductsnike8dry-12-zip-coverup.png"].default
	},
	{
		title: "Utility Speed Backpack 2.0",
		src: imagesGlob["../../images/brands/nike/products/swaggerproductpagewebsiteproductsnike3utility-speed-backpack-20.png"].default
	},
	{
		title: "Dry Essential Solid Polo",
		src: imagesGlob["../../images/brands/nike/products/swaggerproductpagewebsiteproductsnike7dry-essential-solid-polo.png"].default
	},
	{
		title: "Tech Fleece Full-Zip Hoodie",
		src: imagesGlob["../../images/brands/nike/products/swaggerproductpagewebsiteproductsnike2tech-fleece-fullzip-hoodie.png"].default
	},
	{
		title: "Team Cuffed Beanie",
		src: imagesGlob["../../images/brands/nike/products/swaggerproductpagewebsiteproductsnike4team-cuffed-beanie.png"].default
	},
	{
		title: "Brasilia Medium Backpack",
		src: imagesGlob["../../images/brands/nike/products/swaggerproductpagewebsiteproductsnike1brasilia-medium-backpack.png"].default
	},
	{
		title: "Club Fleece Pullover Hoodie",
		src: imagesGlob["../../images/brands/nike/products/swaggerproductpagewebsiteproductsnike11club-fleece-pullover-hoodie.png"].default
	},
	{
		title: "Storm-FIT Full-Zip Jacket",
		src: imagesGlob["../../images/brands/nike/products/swaggerproductpagewebsiteproductsnike5stormfit-fullzip-jacket.png"].default
	},

]
</script>

<template lang="pug">
.page.page--brand.nike
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/nike/logo.png')
				h1 Custom Nike Eco
			.image
				img(src='@static/images/brands/nike/hero.png' alt="Urban scene featuring a man in a bold blue Nike jacket, grey pants, and a grey bag, posing in front of a concrete wall tagged with subtle graffiti, merging sport and street style.")
	section.section.section--subhero
		.section__content
			.copy
				h3 Just Do It
				p Driven by innovation and a relentless pursuit of excellence, custom Nike by Swagger delivers athletic-inspired gear that goes beyond the gym. From high-performance apparel to lifestyle staples, every piece is crafted to empower movement and elevate style. Nike’s legacy is built on breaking boundaries, merging sport, culture, and design to create products that inspire you to push further, play harder, and look good doing it. Whether it’s for training, travel, or everyday wear, Nike gear keeps pace with your ambitions.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src" :alt="`Custom Nike Eco ${product.title}`")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="nike-eco")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/nike/banner.png' alt="Close up of a Nike apparel tag reading 'Collected, Designed, and Recreated in Los Angeles,' highlighting zero waste and sustainable design.")
			.section__content
				.copy
					h2 ZERO WASTE. INFINITE IMPACT.
					p Nike is reimagining the future of sport and the planet with its Move to Zero initiative, a journey toward zero carbon and zero waste. Every step counts, from materials sourced with lower environmental impact to designs built to last and be remade. Collections like those made with Nike Grind and recycled polyester show how innovation can transform waste into performance. By choosing Nike, you’re not just picking iconic gear, you’re joining a movement to protect the game we all love.
		
		section.section.section--foot
			.bg
			.section__content

</template>

<style></style>